<template>
  <el-dialog width="85%" :visible.sync="showSpecialtiesModal" :before-close="applySpecialtyModal"
    :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false"
    title="Select Specialties and Assign Records" @open="saveDisabled = true">
    <el-form>
      <el-row :gutter="10">
        <el-col :span="15">
          <el-row id="specialties">
            <el-col :span="8" v-for="i in [1,2,3]" :key="i">
              <span v-for="s in specialties.slice((i - 1) * 11, i * 11)" :key="s.specialtyId">
                <h4 v-if="s.specialty === 'Other'" class="heading"
                  style="margin-right: 30px; margin-bottom: 5px; padding-bottom: 4px;">Not Listed</h4>
                <el-form-item>
                  <input type="checkbox" @click="toggleProRecord(s)" v-model="s.selected">{{s.specialty}}
                </el-form-item>
              </span>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="9" style="min-height: 300px; border-left: 1px solid #ccc; ">
          <el-alert style=" width: 100%; margin-bottom: 5px;" type="warning"
            v-if="!specialties.some(x => x.selected === true)" :closable="false">Please select at least 1 Specialty
          </el-alert>
          <el-alert style=" width: 100%; margin-bottom: 5px;" type="warning"
            v-if="specialtiesModalMessage && specialties.some(x => x.selected === true && x.numProviders === 0)"
            :closable="false">
            {{specialtiesModalMessage}}</el-alert>
          <el-collapse id="proCollapse" v-model="activeNames" v-show="specialties.some(x => x.selected === true)">
            <el-collapse-item v-for="s in specialties.filter(x => x.selected === true)" :key="s.specialtyId"
              :name="s.specialtyId">
              <template slot="title">
                <el-col :span="12">
                  {{s.specialty}}
                </el-col>
                <el-col :span="12" style="text-align: right; padding: 0px 15px 0px 0px;">
                  {{(getSpecialtyCount(s.specialtyId)) > 0 ? `${(getSpecialtyCount(s.specialtyId))} Records` : ''}}
                </el-col>
              </template>
              <el-row :gutter="3" style="margin: 0px 0px 0px 20px;">
                <el-col :span="14">
                  <strong>Assign Records</strong>
                  <el-form-item label="Number of Providers:">
                    <el-input-number size="mini" v-model="s.numProviders" :min="0">
                    </el-input-number>
                  </el-form-item>
                  <el-form-item label="Number of E&M Accounts Per Provider:">
                    <el-input-number size="mini" v-model="s.numEM" :min="0">
                    </el-input-number>
                  </el-form-item>
                  <el-form-item class="cptPerProvider" label="Number of CPT Accounts Per Provider:">
                    <el-input-number size="mini" v-model="s.numCPT" :min="0">
                    </el-input-number>
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <strong>Place of Service</strong>
                  <div>
                    <input type="checkbox" v-model="s.isHospital">Hospital
                  </div>
                  <div style="padding-bottom: 15px;">
                    <input type="checkbox" v-model="s.isClinic">Clinic
                  </div>
                  <el-form-item label="Other Instructions" class="otherInstructions">
                    <el-input type="textarea" :rows="4" placeholder="Other Instructions" v-model="s.otherInstructions">
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-collapse-item>
          </el-collapse>
          <p class="totalRecords">Total Records: {{getTotalSpecialtyCount()}}</p>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button plain @click="cancelModal">Cancel</el-button>
      <el-button :disabled="!specialties.some(x => x.selected === true)" type="primary" @click="applySpecialtyModal">
        Apply</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    props: {
      showSpecialtiesModal: {
        type: Boolean,
        required: true
      },
      specialties: {
        type: Array,
        required: true
      }
    },
    data: function () {
      return {
        specialtiesModalMessage: '',
        saveDisabled: true,
        proRecords: [],
        activeNames: []
      }
    },
    methods: {
      cancelModal() {
        this.specialtiesModalMessage = ''
        this.$emit('cancel')
      },
      toggleProRecord(row) {
        this.$nextTick(() => {
          if (row.selected) {
            this.activeNames.push(row.specialtyId)
            this.ieSpecialtiesHack()
          } else {
            this.activeNames.splice(this.activeNames.findIndex(x => x === row.specialtyId), 1)
            row.numCPT = 0
            row.numEM = 0
            row.numProviders = 0
            row.isClinic = false
            row.isHospital = false
            row.selected = false

            this.specialties[this.proRecords.findIndex(x => x.specialtyId === row.specialtyId)] = row
          }
        })
      },
      ieSpecialtiesHack() {
        let ua = window.navigator.userAgent
        if (ua.indexOf('Trident/') > 0 || ua.indexOf('Edge/') > 0) {
          // make sure specialty has loaded; wait and adjust height.  Seems to work in IE
          this.$nextTick(() => {
            setTimeout(() => {
              document.querySelector('#proCollapse .el-form-item').style.height = '51px'
            }, 400)
          })
        }
      },
      applySpecialtyModal() {
        if (this.specialties.some(x => x.selected && !x.numProviders)) {
          this.specialtiesModalMessage = 'Please set Records to be Assigned for all selected Specialties'
          return
        }

        this.specialtiesModalMessage = ''
        this.activeNames = []
        this.$emit('apply', this.specialties.filter(x => x.selected === true))
      },
      getSpecialtyCount(id) {
        let item = this.specialties.filter(x => x.specialtyId === id).map(x => x)[0]
        let proRecordsCount = (item.numProviders * item.numEM) + (item.numProviders * item.numCPT)
        return proRecordsCount
      },
      getTotalSpecialtyCount() {
        let selected = this.specialties.filter(x => x.selected)
        let length = selected.length
        let specialtyCount = 0
        let item
        if (length > 0) {
          for (let i = 0; i < length; i++) {
            item = selected[i]
            specialtyCount += (item.numProviders * item.numEM) + (item.numProviders * item.numCPT)
          }
        }
        return specialtyCount
      }
    }
  }
</script>

<style>
  #specialties>>>.el-form-item {
    margin-bottom: 10px;
  }

  .specialties-popover>>>.el-form-item {
    margin-bottom: 5px !important;
  }

  #specialties p {
    line-height: 1;
    margin: 0px 0px 0px 22px;
    max-width: 210px;
    overflow: hidden;
    padding: 2px 1px 2px 1px;
    border-radius: 3px;
    background: rgba(87, 204, 244, .5);
  }

  /* collapse */
  #proCollapse {
    /* box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1); */
    border-top: 1px solid #b4bccc;
    border-bottom: 1px solid #b4bccc;
    /* border-radius: 5px; */
    /* border-right: 1px solid #b4bccc;
    border-left: 1px solid #b4bccc; */
  }

  #proCollapse .el-collapse-item__header {
    height: 30px !important;
    line-height: 30px !important;
    padding-left: 10px;
    border-bottom: 1px solid #b4bccc;
    /* border-top-left-radius: 5px;
    border-top-right-radius: 5px; */
    color: #606266;
    font-weight: 500;
    background: #ffffff !important;
  }

  #proCollapse .el-collapse-item__header:hover {
    background-color: rgb(238, 238, 238) !important;
  }

  #proCollapse .el-collapse-item.is-active .el-collapse-item__header {
    background-color: rgb(238, 238, 238) !important;
  }

  #proCollapse .el-collapse-item.is-active div[aria-controls*="el-collapse-content-"] {
    background-color: rgb(238, 238, 238) !important;
    /* border-top-right-radius: 0px;
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px; */
  }

  #proCollapse .el-form-item {
    padding: 0px 0px 15px 0px;
    height: 50px;
  }

  .totalRecords {
    text-align: right;
    padding-right: 20px;
    font-size: 14px;
  }

  .otherInstructions {
    font-weight: bold;
    color: #303133 !important;
  }
</style>
